import {Injectable, Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {Observable} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {map} from 'rxjs/internal/operators/map';

@Pipe({
    name: 'secureText',
    standalone: false,
})

@Injectable()
export class SecureTextPipe implements PipeTransform {
    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {
    }

    transform(url: string): Observable<{ body: string }> {
        return this.http
            .get(url, {responseType: 'text', observe: 'response' })
            .pipe(
                map((value: HttpResponse<string>) => { return {body: this.sanitizer.sanitize(SecurityContext.HTML, value.body)}; })
            );
    }
}

